<template>
  <div>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="780px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Nova oportunidade
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialog()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formOportunidade">
          <div v-if="etapa === 1">
            <div class="text-center text-h1 mb-3">
              Dados do contato (cliente)
            </div>
            <v-row>
              <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0">
                <v-autocomplete
                  v-model="oportunidade.cliente.cli_tipo"
                  autocomplete="off"
                  :items="tiposPessoa"
                  :loading="salvando"
                  :disabled="salvando || desabilitaTipo"
                  :rules="!desabilitaTipo ? [rules.required] : []"
                  label="Tipo*"
                  append-icon="expand_more"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0">
                <v-combobox
                  v-model="oportunidade.cliente.cli_nome"
                  :items="listaClientes"
                  hide-no-data
                  :search-input.sync="search"
                  :loading="loadingCliente"
                  return-object
                  autofocus
                  outlined
                  autocomplete="off"
                  ref="clientesSelect"
                  :rules="[rules.required]"
                  label="Nome completo*"
                  @keyup="buscaClientes()"
                  @change="checarCampos()"
                ></v-combobox>
                <!-- <v-text-field
                  v-model="oportunidade.cliente.cli_nome"
                  label="Nome*"
                  :rules="[rules.required]"
                  autofocus
                  outlined
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field> -->
              </v-col>
              <v-col cols="12" sm="12" md="5" lg="5" xl="5" class="pt-0 pb-0">
                <v-text-field
                  outlined
                  autocomplete="off"
                  label="Telefone*"
                  :rules="!desabilitaCelular ? [rules.required] : []"
                  v-model="oportunidade.cliente.cli_telefone"
                  v-mask="'(##) #####-####'"
                  :loading="salvando"
                  :disabled="salvando || desabilitaCelular"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="pt-0 pb-0">
                <v-switch
                  hide-details
                  class="ml-0 mt-1"
                  color="success"
                  v-model="oportunidade.cliente.cli_telefone_whats"
                  :loading="salvando"
                  :disabled="salvando"
                  label="Whatsapp"
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="12" md="4" lg="4" xl="4" class="pt-0 pb-0">
                <v-text-field-cep
                  v-model="oportunidade.opu_cep"
                  label="CEP"
                  @change="searchCep(oportunidade.opu_cep)"
                  v-bind:properties="{
                    loading: loadingCep || salvando,
                    disabled: loadingCep || salvando,
                    outlined: true,
                    clearable: true,
                    placeholder: '',
                  }"
                  v-bind:options="{
                    outputMask: '########',
                    empty: '',
                    applyAfter: false,
                  }"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pt-0 pb-0">
                <v-autocomplete
                  v-model="oportunidade.opu_uf"
                  autocomplete="off"
                  :items="estados"
                  :loading="salvando || loadingEstados || loadingCep"
                  :disabled="salvando || loadingEstados || loadingCep"
                  label="Estado"
                  append-icon="expand_more"
                  outlined
                  @change="filterCidade(oportunidade.opu_uf)"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pt-0 pb-0">
                <v-autocomplete
                  autocomplete="off"
                  v-model="oportunidade.opu_cidade"
                  :items="cidadesFiltradas"
                  :loading="salvando || loadingCidades || loadingCep"
                  :disabled="salvando || loadingCidades || loadingCep"
                  label="Cidade"
                  append-icon="expand_more"
                  outlined
                ></v-autocomplete>
              </v-col>
               <v-col cols="12" sm="12" md="4" lg="4" xl="4" class="pb-0 pt-0">
                <v-text-field
                  v-model="oportunidade.opu_bairro"
                  outlined
                  :loading="salvando || loadingCep"
                  :disabled="salvando || loadingCep"
                  label="Bairro"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0 pt-0">
                <v-text-field
                  v-model="oportunidade.opu_rua"
                  outlined
                  :loading="salvando || loadingCep"
                  :disabled="salvando || loadingCep"
                  label="Rua"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="2" lg="2" xl="2" class="pt-0 pb-0">
                <v-text-field
                  v-model="oportunidade.opu_numero"
                  outlined
                  :loading="salvando || loadingCep"
                  :disabled="salvando || loadingCep"
                  label="Nº"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="pt-0">
                <v-text-field
                  v-model="oportunidade.opu_complemento"
                  outlined
                  :loading="salvando || loadingCep"
                  :disabled="salvando || loadingCep"
                  label="Complemento"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>
          <div v-if="etapa === 2">
            <div class="text-center text-h1 mb-3">
              Dados da conta de energia
            </div>
            <v-row>
              <v-col cols="12" sm="12" md="4" lg="4" xl="4" class="pb-0">
                <v-autocomplete
                  v-model="oportunidade.conta.opc_modalidade_tarifaria"
                  autocomplete="off"
                  :items="modalidades"
                  :loading="salvando"
                  :disabled="salvando"
                  :rules="[rules.required]"
                  label="Modalidade tarifária*"
                  append-icon="expand_more"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="4" lg="4" xl="4" class="pb-0">
                <v-autocomplete
                  v-model="oportunidade.conta.opc_entrada_padrao"
                  autocomplete="off"
                  :items="padroes"
                  :loading="salvando"
                  :disabled="salvando"
                  :rules="[rules.required]"
                  label="Padrão de entrada*"
                  append-icon="expand_more"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="4" lg="4" xl="4" class="pb-0">
                <v-text-field
                  v-model="oportunidade.conta.opc_unidade_consumidora"
                  label="Unidade consumidora"
                  autofocus
                  outlined
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0 pt-0">
                <v-text-field
                  v-model="oportunidade.conta.opc_unidade_consumidora_descricao"
                  label="Descrição unidade consumidora"
                  outlined
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="4" lg="4" xl="4" class="pt-0">
                <v-text-field-percent
                  label="Consumo médio (kWh)*"
                  outlined
                  v-model="oportunidade.conta.opc_consumo_mensal"
                  v-bind:properties="{
                    readonly: false,
                    hideDetails: true,
                    outlined: true,
                    disabled: salvando,
                    loading: salvando,
                    rules: [rules.required]
                  }"
                  v-bind:options="{
                    locale: 'pt-BR',
                    length: 12,
                    precision: 2,
                    empty: '',
                  }"
                ></v-text-field-percent>
              </v-col>
              <v-col cols="12" sm="12" md="1" lg="1" xl="1" class="pt-0 pl-0">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" class="ui-btn-clean py-2 w-100 px-0" v-bind="attrs" v-on="on" @click="openDialogInfo()">
                      <v-icon>list_alt</v-icon>
                    </v-btn>
                  </template>
                  <span>Calcular consumo</span>
                </v-tooltip>
              </v-col>
              <v-col cols="12" sm="12" md="4" lg="4" xl="4" class="pt-0">
                <v-text-field-percent
                  label="Consumo mínimo (kWh)*"
                  outlined
                  v-model="oportunidade.opc_consumo_minimo"
                  v-bind:properties="{
                    readonly: false,
                    hideDetails: true,
                    outlined: true,
                    disabled: salvando,
                    loading: salvando,
                    rules: [rules.required]
                  }"
                  v-bind:options="{
                    locale: 'pt-BR',
                    length: 12,
                    precision: 2,
                    empty: '',
                  }"
                ></v-text-field-percent>
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="pt-0">
                <vuetify-money
                  lazy-validation
                  v-model="oportunidade.conta.opc_valor_kwh"
                  :backgroundColor="$vuetify.theme.dark ? '#1e1e1e00' : '#fff'"
                  :disabled="salvando"
                  :loading="salvando"
                  outlined
                  :options="optionsMoney"
                  valueWhenIsEmpty=""
                  :rules="[rules.required]"
                  label="Preço do kWh do contato*"
                ></vuetify-money>
              </v-col>
            </v-row>
          </div>
          <div v-if="etapa === 3">
            <div class="text-center text-h1 mb-3">
              Detalhes da oportunidade
            </div>
            <v-row>
              <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                <v-autocomplete
                  v-model="oportunidade.opu_tipo"
                  autocomplete="off"
                  :items="tiposDeOportunidade"
                  :loading="salvando"
                  :disabled="salvando"
                  :rules="[rules.required]"
                  label="Tipo da oportunidade*"
                  append-icon="expand_more"
                  outlined
                  class="mb-2"
                ></v-autocomplete>
                <v-autocomplete
                  v-model="oportunidade.opu_tipo_instalacao"
                  autocomplete="off"
                  :items="tiposInstalacao"
                  :loading="salvando"
                  :disabled="salvando"
                  :rules="[rules.required]"
                  label="Tipo de instalação*"
                  append-icon="expand_more"
                  outlined
                  class="mb-1"
                ></v-autocomplete>
                <v-autocomplete
                  v-model="oportunidade.opu_probabilidade"
                  autocomplete="off"
                  :items="chances"
                  :loading="salvando"
                  :disabled="salvando"
                  :rules="[rules.required]"
                  label="Chance de fechar negociação*"
                  append-icon="expand_more"
                  outlined
                  class="mb-1"
                ></v-autocomplete>
                <v-autocomplete
                  v-model="oportunidade.opu_tipo_estrutura"
                  autocomplete="off"
                  :items="tiposEstrutura"
                  :loading="salvando"
                  :disabled="salvando"
                  :rules="[rules.required]"
                  label="Tipo de estrutura*"
                  append-icon="expand_more"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                <v-textarea
                  outlined
                  autofocus
                  no-resize
                  rows="6"
                  counter
                  :rules="[rules.required, rules.max]"
                  v-model="oportunidade.opu_observacao"
                  :loading="salvando"
                  :disabled="salvando"
                  label="Descreva a nova oportunidade*"
                ></v-textarea>
              </v-col>
            </v-row>
          </div>
         </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            v-if="etapa === 1"
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="closeDialog()"
          >
            Cancelar
          </v-btn>
          <v-btn
            v-if="etapa !== 1"
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="etapa = etapa - 1"
          >
            Voltar
          </v-btn>
          <v-btn
            v-if="etapa !== 3"
            color="primary"
            @click="avancarEtapa()"
            :loading="salvando"
            :disabled="salvando"
          >
            Avançar
          </v-btn>
          <v-btn
            v-if="etapa === 3"
            color="primary"
            @click="salvarOportunidade()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogInfo"
      persistent
      max-width="900px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Calcular Consumo
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialogInfo()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formConsumo">
          <v-row class="mb-2">
            <v-col cols="12" sm="2" md="2" lg="2" xl="2">
              <v-text-field-percent
                autofocus
                label="Janeiro"
                outlined
                @change="atualizaCamposConsumo(oportunidade.conta.opc_consumo_jan)"
                v-model="oportunidade.conta.opc_consumo_jan"
                v-bind:properties="{
                  readonly: false,
                  hideDetails: true,
                  outlined: true,
                  disabled: salvando,
                  loading: salvando
                }"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 12,
                  precision: 2,
                  empty: '',
                }"
              ></v-text-field-percent>
            </v-col>
            <v-col cols="12" sm="2" md="2" lg="2" xl="2">
              <v-text-field-percent
                label="Fevereiro"
                outlined
                v-model="oportunidade.conta.opc_consumo_fev"
                @change="atualizaCamposConsumo(oportunidade.conta.opc_consumo_fev)"
                v-bind:properties="{
                  readonly: false,
                  hideDetails: true,
                  outlined: true,
                  disabled: salvando,
                  loading: salvando
                }"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 12,
                  precision: 2,
                  empty: '',
                }"
              ></v-text-field-percent>
            </v-col>
            <v-col cols="12" sm="2" md="2" lg="2" xl="2">
              <v-text-field-percent
                label="Março"
                outlined
                v-model="oportunidade.conta.opc_consumo_mar"
                @change="atualizaCamposConsumo(oportunidade.conta.opc_consumo_mar)"
                v-bind:properties="{
                  readonly: false,
                  hideDetails: true,
                  outlined: true,
                  disabled: salvando,
                  loading: salvando
                }"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 12,
                  precision: 2,
                  empty: '',
                }"
              ></v-text-field-percent>
            </v-col>
            <v-col cols="12" sm="2" md="2" lg="2" xl="2">
              <v-text-field-percent
                label="Abril"
                outlined
                v-model="oportunidade.conta.opc_consumo_abr"
                @change="atualizaCamposConsumo(oportunidade.conta.opc_consumo_abr)"
                v-bind:properties="{
                  readonly: false,
                  hideDetails: true,
                  outlined: true,
                  disabled: salvando,
                  loading: salvando
                }"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 12,
                  precision: 2,
                  empty: '',
                }"
              ></v-text-field-percent>
            </v-col>
            <v-col cols="12" sm="2" md="2" lg="2" xl="2">
              <v-text-field-percent
                label="Maio"
                outlined
                v-model="oportunidade.conta.opc_consumo_mai"
                @change="atualizaCamposConsumo(oportunidade.conta.opc_consumo_mai)"
                v-bind:properties="{
                  readonly: false,
                  hideDetails: true,
                  outlined: true,
                  disabled: salvando,
                  loading: salvando
                }"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 12,
                  precision: 2,
                  empty: '',
                }"
              ></v-text-field-percent>
            </v-col>
            <v-col cols="12" sm="2" md="2" lg="2" xl="2">
              <v-text-field-percent
                label="Junho"
                outlined
                v-model="oportunidade.conta.opc_consumo_jun"
                @change="atualizaCamposConsumo(oportunidade.conta.opc_consumo_jun)"
                v-bind:properties="{
                  readonly: false,
                  hideDetails: true,
                  outlined: true,
                  disabled: salvando,
                  loading: salvando
                }"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 12,
                  precision: 2,
                  empty: '',
                }"
              ></v-text-field-percent>
            </v-col>
            <v-col cols="12" sm="2" md="2" lg="2" xl="2">
              <v-text-field-percent
                label="Julho"
                outlined
                v-model="oportunidade.conta.opc_consumo_jul"
                @change="atualizaCamposConsumo(oportunidade.conta.opc_consumo_jul)"
                v-bind:properties="{
                  readonly: false,
                  hideDetails: true,
                  outlined: true,
                  disabled: salvando,
                  loading: salvando
                }"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 12,
                  precision: 2,
                  empty: '',
                }"
              ></v-text-field-percent>
            </v-col>
            <v-col cols="12" sm="2" md="2" lg="2" xl="2">
              <v-text-field-percent
                label="Agosto"
                outlined
                v-model="oportunidade.conta.opc_consumo_ago"
                @change="atualizaCamposConsumo(oportunidade.conta.opc_consumo_ago)"
                v-bind:properties="{
                  readonly: false,
                  hideDetails: true,
                  outlined: true,
                  disabled: salvando,
                  loading: salvando
                }"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 12,
                  precision: 2,
                  empty: '',
                }"
              ></v-text-field-percent>
            </v-col>
            <v-col cols="12" sm="2" md="2" lg="2" xl="2">
              <v-text-field-percent
                label="Setembro"
                outlined
                v-model="oportunidade.conta.opc_consumo_set"
                @change="atualizaCamposConsumo(oportunidade.conta.opc_consumo_set)"
                v-bind:properties="{
                  readonly: false,
                  hideDetails: true,
                  outlined: true,
                  disabled: salvando,
                  loading: salvando
                }"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 12,
                  precision: 2,
                  empty: '',
                }"
              ></v-text-field-percent>
            </v-col>
            <v-col cols="12" sm="2" md="2" lg="2" xl="2">
              <v-text-field-percent
                label="Outubro"
                outlined
                v-model="oportunidade.conta.opc_consumo_out"
                @change="atualizaCamposConsumo(oportunidade.conta.opc_consumo_out)"
                v-bind:properties="{
                  readonly: false,
                  hideDetails: true,
                  outlined: true,
                  disabled: salvando,
                  loading: salvando
                }"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 12,
                  precision: 2,
                  empty: '',
                }"
              ></v-text-field-percent>
            </v-col>
            <v-col cols="12" sm="2" md="2" lg="2" xl="2">
              <v-text-field-percent
                label="Novembro"
                outlined
                v-model="oportunidade.conta.opc_consumo_nov"
                @change="atualizaCamposConsumo(oportunidade.conta.opc_consumo_nov)"
                v-bind:properties="{
                  readonly: false,
                  hideDetails: true,
                  outlined: true,
                  disabled: salvando,
                  loading: salvando
                }"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 12,
                  precision: 2,
                  empty: '',
                }"
              ></v-text-field-percent>
            </v-col>
            <v-col cols="12" sm="2" md="2" lg="2" xl="2">
              <v-text-field-percent
                label="Dezembro"
                outlined
                v-model="oportunidade.conta.opc_consumo_dez"
                @change="atualizaCamposConsumo(oportunidade.conta.opc_consumo_dez)"
                v-bind:properties="{
                  readonly: false,
                  hideDetails: true,
                  outlined: true,
                  disabled: salvando,
                  loading: salvando
                }"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 12,
                  precision: 2,
                  empty: '',
                }"
              ></v-text-field-percent>
            </v-col>
            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
              <v-text-field-percent
                label="Consumo médio (kWh)"
                outlined
                v-model="oportunidade.conta.opc_consumo_mensal"
                v-bind:properties="{
                  readonly: false,
                  hideDetails: true,
                  disabled: salvando,
                  outlined: true,
                  loading: salvando
                }"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 12,
                  precision: 2,
                  empty: '',
                }"
              ></v-text-field-percent>
            </v-col>
            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
              <v-text-field-percent
                label="RSI médio"
                outlined
                v-model="oportunidade.opu_irradiacao_diaria"
                v-bind:properties="{
                  readonly: false,
                  hideDetails: true,
                  disabled: salvando,
                  outlined: true,
                  loading: salvando
                }"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 12,
                  precision: 2,
                  empty: '',
                }"
              ></v-text-field-percent>
            </v-col>
            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
              <v-text-field-percent
                label="Perda (%)"
                outlined
                v-model="oportunidade.opu_percentual_perda"
                v-bind:properties="{
                  readonly: false,
                  hideDetails: true,
                  outlined: true,
                  disabled: salvando,
                  loading: salvando
                }"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 12,
                  precision: 2,
                  empty: '',
                }"
              ></v-text-field-percent>
            </v-col>
            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
              <v-text-field-percent
                label="Potência desejada (kWp)"
                outlined
                v-model="oportunidade.opu_potencia_desejada"
                v-bind:properties="{
                  readonly: false,
                  hideDetails: true,
                  outlined: true,
                  disabled: salvando,
                  loading: salvando
                }"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 12,
                  precision: 2,
                  empty: '',
                }"
              ></v-text-field-percent>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
            <v-btn
              color="cancel"
              @click="closeDialogInfo()"
              :loading="salvando"
              :disabled="salvando"
            >
              Fechar
            </v-btn>
          </v-row>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from '@API'
import _debounce from 'lodash.debounce'
import axios from 'axios'
export default {
  props: ['abrir_dialog'],
  data () {
    return {
      etapa: 1,
      rules: {
        required: value => !!value || 'Obrigatório.',
        max: v => v.length <= 400 || 'Máximo de 400 caracteres'
      },
      salvando: false,
      dialog: false,
      dialogInfo: false,
      search: null,
      loadingCliente: false,
      listaClientes: [],
      tiposPessoa: [
        {
          text: 'Pessoa Física',
          value: 1
        },
        {
          text: 'Pessoa Jurídica',
          value: 2
        }
      ],
      modalidades: [
        {
          text: 'Grupo B - Convencional',
          value: 1
        },
        {
          text: 'Grupo A - Verde',
          value: 2
        },
        {
          text: 'Grupo A - Azul',
          value: 3
        }
      ],
      padroes: [
        {
          text: 'Monofásico',
          value: 1
        },
        {
          text: 'Bifásico',
          value: 2
        },
        {
          text: 'Trifásico',
          value: 3
        }
      ],
      distribuidoras: [
        {
          text: 'Amazonas energia',
          value: 1
        }
      ],
      loadingCep: false,
      loadingEstados: false,
      loadingCidades: false,
      estados: [],
      cidades: [],
      cidadesFiltradas: [],
      optionsMoney: {
        locale: 'pt-BR',
        prefix: 'R$',
        suffix: '',
        length: 10,
        precision: 2
      },
      tiposDeOportunidade: [
        {
          text: 'Sistema Fotovoltaico',
          value: 1
        },
        {
          text: 'Aquecedor Solar',
          value: 2
        },
        {
          text: 'Serviço',
          value: 3
        },
        {
          text: 'Carregador Veicular',
          value: 4
        }
      ],
      tiposInstalacao: [
        {
          text: 'Comercial',
          value: 1
        },
        {
          text: 'Industrial',
          value: 2
        },
        {
          text: 'Residencial',
          value: 3
        },
        {
          text: 'Rural',
          value: 4
        },
        {
          text: 'Outros',
          value: 5
        }
      ],
      chances: [
        {
          text: 'Alta',
          value: 1
        },
        {
          text: 'Média',
          value: 2
        },
        {
          text: 'Baixa',
          value: 3
        },
        {
          text: 'Não sei',
          value: 4
        }
      ],
      tiposEstrutura: [],
      desabilitaTipo: false,
      desabilitaCelular: false,
      oportunidade: {
        opu_tipo: 1,
        opu_cep: '',
        opu_uf: '',
        opu_cidade: '',
        opu_bairro: '',
        opu_rua: '',
        opu_numero: '',
        opu_complemento: '',
        opu_tipo_instalacao: 1,
        opu_probabilidade: 3,
        opu_tipo_estrutura: 1,
        opu_observacao: '',
        opc_consumo_minimo: '',
        opu_irradiacao_diaria: '',
        opu_percentual_perda: '',
        opu_potencia_desejada: '',
        conta: {
          opc_modalidade_tarifaria: 1,
          opc_entrada_padrao: 1,
          opc_unidade_consumidora: '',
          opc_unidade_consumidora_descricao: 'Padrão',
          opc_consumo_mensal: '',
          opc_consumo_jan: '',
          opc_consumo_fev: '',
          opc_consumo_mar: '',
          opc_consumo_abr: '',
          opc_consumo_mai: '',
          opc_consumo_jun: '',
          opc_consumo_jul: '',
          opc_consumo_ago: '',
          opc_consumo_set: '',
          opc_consumo_out: '',
          opc_consumo_nov: '',
          opc_consumo_dez: '',
          opc_valor_kwh: ''
        },
        cliente: {
          cli_tipo: 1,
          cli_nome: '',
          cli_telefone: '',
          cli_telefone_whats: true
        },
        uuid_cli_id: '',
        uuid_int_id: ''
      }
    }
  },
  watch: {
    search (val) {
      this.serchField = val
    },
    abrir_dialog () {
      this.dialog = !this.dialog
    }
  },
  methods: {
    closeDialog () {
      this.etapa = 1
      this.oportunidade = {
        opu_tipo: 1,
        opu_cep: '',
        opu_uf: '',
        opu_cidade: '',
        opu_bairro: '',
        opu_rua: '',
        opu_numero: '',
        opu_complemento: '',
        opu_tipo_instalacao: 1,
        opu_probabilidade: 3,
        opu_tipo_estrutura: 1,
        opu_observacao: '',
        opc_consumo_minimo: '',
        opu_irradiacao_diaria: '',
        opu_percentual_perda: '',
        opu_potencia_desejada: '',
        conta: {
          opc_modalidade_tarifaria: 1,
          opc_entrada_padrao: 1,
          opc_unidade_consumidora: '',
          opc_unidade_consumidora_descricao: 'Padrão',
          opc_consumo_mensal: '',
          opc_consumo_jan: '',
          opc_consumo_fev: '',
          opc_consumo_mar: '',
          opc_consumo_abr: '',
          opc_consumo_mai: '',
          opc_consumo_jun: '',
          opc_consumo_jul: '',
          opc_consumo_ago: '',
          opc_consumo_set: '',
          opc_consumo_out: '',
          opc_consumo_nov: '',
          opc_consumo_dez: '',
          opc_valor_kwh: ''
        },
        cliente: {
          cli_tipo: 1,
          cli_nome: '',
          cli_telefone: '',
          cli_telefone_whats: true
        },
        uuid_cli_id: '',
        uuid_int_id: ''
      }
      this.desabilitaTipo = false
      this.desabilitaCelular = false
      if (this.$refs.formOportunidade) {
        this.$refs.formOportunidade.resetValidation()
      }
      this.$emit('cancelar-close')
    },
    closeDialogInfo () {
      this.dialogInfo = false
      if (this.$refs.formConsumo) {
        this.$refs.formConsumo.resetValidation()
      }
    },
    atualizaCamposConsumo (valor) {
      if (this.oportunidade.conta.opc_consumo_jan === '') {
        this.oportunidade.conta.opc_consumo_jan = valor
      }
      if (this.oportunidade.conta.opc_consumo_fev === '') {
        this.oportunidade.conta.opc_consumo_fev = valor
      }
      if (this.oportunidade.conta.opc_consumo_mar === '') {
        this.oportunidade.conta.opc_consumo_mar = valor
      }
      if (this.oportunidade.conta.opc_consumo_abr === '') {
        this.oportunidade.conta.opc_consumo_abr = valor
      }
      if (this.oportunidade.conta.opc_consumo_mai === '') {
        this.oportunidade.conta.opc_consumo_mai = valor
      }
      if (this.oportunidade.conta.opc_consumo_jun === '') {
        this.oportunidade.conta.opc_consumo_jun = valor
      }
      if (this.oportunidade.conta.opc_consumo_jul === '') {
        this.oportunidade.conta.opc_consumo_jul = valor
      }
      if (this.oportunidade.conta.opc_consumo_ago === '') {
        this.oportunidade.conta.opc_consumo_ago = valor
      }
      if (this.oportunidade.conta.opc_consumo_set === '') {
        this.oportunidade.conta.opc_consumo_set = valor
      }
      if (this.oportunidade.conta.opc_consumo_out === '') {
        this.oportunidade.conta.opc_consumo_out = valor
      }
      if (this.oportunidade.conta.opc_consumo_nov === '') {
        this.oportunidade.conta.opc_consumo_nov = valor
      }
      if (this.oportunidade.conta.opc_consumo_dez === '') {
        this.oportunidade.conta.opc_consumo_dez = valor
      }
      this.calculaMediaConta()
    },
    calculaMediaConta () {
      let valor = 0
      valor = (Number(this.oportunidade.conta.opc_consumo_jan) + Number(this.oportunidade.conta.opc_consumo_fev) + Number(this.oportunidade.conta.opc_consumo_mar) + Number(this.oportunidade.conta.opc_consumo_abr) + Number(this.oportunidade.conta.opc_consumo_mai) + Number(this.oportunidade.conta.opc_consumo_jun) + Number(this.oportunidade.conta.opc_consumo_jul) + Number(this.oportunidade.conta.opc_consumo_ago) + Number(this.oportunidade.conta.opc_consumo_set) + Number(this.oportunidade.conta.opc_consumo_out) + Number(this.oportunidade.conta.opc_consumo_nov) + Number(this.oportunidade.conta.opc_consumo_dez)) / 12
      this.oportunidade.conta.opc_consumo_mensal = valor
    },
    checarCampos () {
      if (this.oportunidade.cliente.cli_nome && this.oportunidade.cliente.cli_nome.text) {
        this.oportunidade.uuid_cli_id = this.oportunidade.cliente.cli_nome.value
        this.oportunidade.cliente.cli_tipo = this.oportunidade.cliente.cli_nome.cli_tipo
        this.oportunidade.cliente.cli_telefone = this.oportunidade.cliente.cli_nome.cli_telefone
        this.oportunidade.opu_cep = this.oportunidade.cliente.cli_nome.cli_cep
        this.oportunidade.opu_uf = this.oportunidade.cliente.cli_nome.cli_uf
        this.oportunidade.opu_cidade = this.oportunidade.cliente.cli_nome.cli_cidade
        this.oportunidade.opu_bairro = this.oportunidade.cliente.cli_nome.cli_bairro
        this.oportunidade.opu_rua = this.oportunidade.cliente.cli_nome.cli_rua
        this.oportunidade.opu_numero = this.oportunidade.cliente.cli_nome.cli_numero
        this.oportunidade.opu_complemento = this.oportunidade.cliente.cli_nome.cli_complemento
        this.desabilitaTipo = true
        this.desabilitaCelular = true
        if (this.oportunidade.cliente.cli_nome.cli_uf) {
          this.filterCidade(this.oportunidade.cliente.cli_nome.cli_uf)
        }
        this.oportunidade.cliente.cli_nome = this.oportunidade.cliente.cli_nome.text
      } else {
        this.desabilitaTipo = false
        this.desabilitaCelular = false
        this.oportunidade.uuid_cli_id = ''
      }
      console.log(this.oportunidade.cliente.cli_nome)
      // console.log(this.search)
      // console.log(this.oportunidade.cliente.cli_nome)
    },
    buscaClientes: _debounce(function () {
      if (this.serchField.length <= 3) return
      this.getClientes()
    }, 500),
    getClientes () {
      this.loadingCliente = true
      this.listaClientes = []
      Api.get('clientes?busca=' + this.serchField)
        .then(res => {
          res.data.map((data) => {
            if (data && data.cli_nome) {
              this.listaClientes.push({
                text: data.cli_nome,
                value: data.uuid_cli_id,
                cli_tipo: data.cli_tipo,
                cli_telefone: data.cli_celular,
                cli_cep: data.cli_cep,
                cli_uf: data.cli_uf,
                cli_cidade: data.cli_cidade,
                cli_rua: data.cli_rua,
                cli_numero: data.cli_numero,
                cli_bairro: data.cli_bairro,
                cli_complemento: data.cli_complemento
              })
            }
          })
          this.loadingCliente = false
          setTimeout(() => {
            this.$refs.clientesSelect.focus()
          }, 100)
        })
        .catch(err => {
          console.log(err)
          this.loadingCliente = false
          this.$root.SnackControl.open(this, {
            text: 'Erro ao buscar clientes!',
            color: 'error'
          })
        })
    },
    loadFunctions () {
      this.getCidade()
      this.getEstados()
      this.getTiposEstrutura()
    },
    openDialogInfo () {
      this.dialogInfo = true
    },
    async salvarOportunidade () {
      if (!this.$refs.formOportunidade.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      if (this.oportunidade.conta.opc_unidade_consumidora_descricao === '') {
        this.oportunidade.conta.opc_unidade_consumidora_descricao = 'Padrão'
      }
      await Api.post('oportunidades/novo', this.oportunidade)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: 'Oportunidade cadastrada com sucesso!',
            color: 'success'
          })
          this.closeDialog()
          this.$router.push({ name: 'OportunidadeInterna', params: { uuid: response.data.uuid_opu_id } }).catch(() => {})
        })
        .catch((error) => {
          this.salvando = false
          console.log(error)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    avancarEtapa () {
      if (!this.$refs.formOportunidade.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.etapa = this.etapa + 1
    },
    searchCep (cep = '') {
      if (cep.length === 8) {
        this.loadingCep = true
        axios.get('https://viacep.com.br/ws/' + cep + '/json/')
          .then((response) => {
            if (!response.data.erro) {
              this.oportunidade.opu_rua = response.data.logradouro
              this.oportunidade.opu_bairro = response.data.bairro
              this.oportunidade.opu_complemento = response.data.complemento
              if (response.data.uf) {
                this.oportunidade.opu_uf = response.data.uf
                this.oportunidade.opu_cidade = response.data.localidade
                this.filterCidade(response.data.uf)
              }
            }
          })
          .catch(err => {
            console.log(err)
            this.$root.SnackControl.open(this, {
              text: 'Erro ao buscar por CEP!',
              color: 'error'
            })
          }).finally(() => {
            this.loadingCep = false
          })
      }
    },
    getEstados () {
      this.loadingEstados = true
      axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome')
        .then((response) => {
          for (let estado = 0; estado < response.data.length; estado++) {
            this.estados.push({
              text: response.data[estado].nome,
              value: response.data[estado].sigla
            })
          }
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Erro ao buscar os estados!',
            color: 'error'
          })
        })
      this.loadingEstados = false
    },
    getCidade () {
      this.loadingCidades = true
      axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/municipios')
        .then((response) => {
          for (let cidade = 0; cidade < response.data.length; cidade++) {
            this.cidades.push({
              text: response.data[cidade].nome,
              value: response.data[cidade].nome,
              uf: response.data[cidade].microrregiao.mesorregiao.UF.sigla
            })
          }
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Erro ao buscar as cidades!',
            color: 'error'
          })
        })
      this.loadingCidades = false
    },
    filterCidade (estado) {
      this.cidadesFiltradas = this.cidades.filter(city => city.uf === estado)
    },
    async getTiposEstrutura () {
      this.loading = true
      await Api.get('tipos-estruturas')
        .then(res => {
          if (res.data && res.data.length > 0) {
            let info = []
            res.data.map(item => {
              info.push({
                text: item.tie_nome,
                value: item.tie_id
              })
            })
            this.tiposEstrutura = info
          } else {
            this.tiposEstrutura = []
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os tipos de estruturas!',
            color: 'error'
          })
          console.log(err)
        })
    }
  },
  created () {
    this.loadFunctions()
  }
}
</script>
<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
.value_area {
  font-size: 14px;
  font-weight: bold;
  line-height: normal;
  margin-top: 3px;
  text-align: right;
}
.value_area_porcentagem {
  font-size: 14px;
  line-break: normal;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/pages/oportunidades/NovaOportunidade.vue